'use strict';
import moment from 'moment';

const main = (year, month) => {
  if(parseInt(month[0]) === 0) month = `${month[1]}`;
  const days = [];
  let day = 1;
  while (day <= new Date(year, month, 0).getDate()) {
    const date = new Date(`${year}-${month}-${day}`);
    days.push({ 
      number: day, 
      weekday: moment(date).format('dddd') 
    });
    day++;
  }
  return days;  
};

export default main;